import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { Mark } from '../common/Logo';

const CTASection = () => {
  return (
    <section className="relative py-28 md:py-36 overflow-hidden bg-canvas-black">
      <div className="absolute inset-0 bg-radial-amber pointer-events-none" />
      <div className="absolute inset-0 grid-bg opacity-60 pointer-events-none" />

      <div className="container-prose relative">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mx-auto text-center"
        >
          <div className="flex justify-center mb-8">
            <Mark size={48} />
          </div>
          <h2 className="text-display font-bold text-canvas-white text-balance">
            See coretrade run on{' '}
            <span className="bg-gradient-to-r from-amber via-amber-light to-amber bg-clip-text text-transparent">
              your own confirmations
            </span>.
          </h2>
          <p className="mt-7 text-[16.5px] leading-relaxed text-ink-faint max-w-xl mx-auto text-balance">
            We're booking 30-minute demos with Gulf trading desks ahead of launch. Bring
            a handful of (redacted) past confirmations — we'll show you what the
            workflow looks like with the manual step removed.
          </p>

          <div className="mt-10 flex items-center justify-center gap-3">
            <Button to="/request-demo" variant="primary" size="lg" withArrow>
              Book a demo
            </Button>
            <Link
              to="/product"
              className="group inline-flex items-center gap-1.5 text-[14.5px] font-medium text-canvas-white/80 hover:text-canvas-white transition-colors px-2 py-3"
            >
              See the product
              <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" />
            </Link>
          </div>

          <p className="mt-9 text-[12px] text-ink-faint/80">
            Building for desks across <span className="text-canvas-white/80">Doha</span>,{' '}
            <span className="text-canvas-white/80">Riyadh</span>,{' '}
            <span className="text-canvas-white/80">Dubai</span> and{' '}
            <span className="text-canvas-white/80">Abu Dhabi</span>.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
